// Country model:
// [
//    Country name,
//    Regions,
//    iso2 code,
//    International dial code,
//    Format (if available),
//    Order priority (if >1 country with same dial code),
//    Area codes (if >1 country with same dial code)
// ]
//
// Regions:
// ['america', 'europe', 'asia', 'oceania', 'africa']
//
// Sub-regions:
// ['north-america', 'south-america', 'central-america', 'carribean',
//  'eu-union', 'ex-ussr', 'ex-yugos', 'baltic', 'middle-east', 'north-africa']

interface RawCountry {
  0: string; // Country name
  1: string[]; // Regions
  2: string; // iso2 code
  3: string; // International dial code
  4?: string; // Format (if available)
  5?: number; // Order priority (if >1 country with same dial code)
  6?: string[]; // Area codes (if >1 country with same dial code)
}

interface MappedCountries {
  [key: string]: {
    countryCode: string;
    isoCode: string | null;
  };
}

const rawCountries: RawCountry[] = [
  [
    "United States",
    ["america", "north-america"],
    "us",
    "1",
    "(...) ...-....",
    0,
    [
      "907",
      "205",
      "251",
      "256",
      "334",
      "479",
      "501",
      "870",
      "480",
      "520",
      "602",
      "623",
      "928",
      "209",
      "213",
      "310",
      "323",
      "408",
      "415",
      "510",
      "530",
      "559",
      "562",
      "619",
      "626",
      "650",
      "661",
      "707",
      "714",
      "760",
      "805",
      "818",
      "831",
      "858",
      "909",
      "916",
      "925",
      "949",
      "951",
      "303",
      "719",
      "970",
      "203",
      "860",
      "202",
      "302",
      "239",
      "305",
      "321",
      "352",
      "386",
      "407",
      "561",
      "727",
      "772",
      "813",
      "850",
      "863",
      "904",
      "941",
      "954",
      "229",
      "404",
      "478",
      "706",
      "770",
      "912",
      "808",
      "319",
      "515",
      "563",
      "641",
      "712",
      "208",
      "217",
      "309",
      "312",
      "618",
      "630",
      "708",
      "773",
      "815",
      "847",
      "219",
      "260",
      "317",
      "574",
      "765",
      "812",
      "316",
      "620",
      "785",
      "913",
      "270",
      "502",
      "606",
      "859",
      "225",
      "318",
      "337",
      "504",
      "985",
      "413",
      "508",
      "617",
      "781",
      "978",
      "301",
      "410",
      "207",
      "231",
      "248",
      "269",
      "313",
      "517",
      "586",
      "616",
      "734",
      "810",
      "906",
      "989",
      "218",
      "320",
      "507",
      "612",
      "651",
      "763",
      "952",
      "314",
      "417",
      "573",
      "636",
      "660",
      "816",
      "228",
      "601",
      "662",
      "406",
      "252",
      "336",
      "704",
      "828",
      "910",
      "919",
      "701",
      "308",
      "402",
      "603",
      "201",
      "609",
      "732",
      "856",
      "908",
      "973",
      "505",
      "575",
      "702",
      "775",
      "212",
      "315",
      "516",
      "518",
      "585",
      "607",
      "631",
      "716",
      "718",
      "845",
      "914",
      "216",
      "330",
      "419",
      "440",
      "513",
      "614",
      "740",
      "937",
      "405",
      "580",
      "918",
      "503",
      "541",
      "215",
      "412",
      "570",
      "610",
      "717",
      "724",
      "814",
      "401",
      "803",
      "843",
      "864",
      "605",
      "423",
      "615",
      "731",
      "865",
      "901",
      "931",
      "210",
      "214",
      "254",
      "281",
      "325",
      "361",
      "409",
      "432",
      "512",
      "713",
      "806",
      "817",
      "830",
      "903",
      "915",
      "936",
      "940",
      "956",
      "972",
      "979",
      "435",
      "801",
      "276",
      "434",
      "540",
      "703",
      "757",
      "804",
      "802",
      "206",
      "253",
      "360",
      "425",
      "509",
      "262",
      "414",
      "608",
      "715",
      "920",
      "304",
      "307",
    ],
  ],
  [
    "Canada",
    ["america", "north-america"],
    "ca",
    "1",
    "(...) ...-....",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905",
    ],
  ],
  ["Afghanistan", ["asia"], "af", "93"],
  ["Albania", ["europe"], "al", "355"],
  ["Algeria", ["africa", "north-africa"], "dz", "213"],
  ["Andorra", ["europe"], "ad", "376"],
  ["Angola", ["africa"], "ao", "244"],
  ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"],
  [
    "Argentina",
    ["america", "south-america"],
    "ar",
    "54",
    "(..) ........",
    0,
    [
      "11",
      "221",
      "223",
      "261",
      "264",
      "2652",
      "280",
      "2905",
      "291",
      "2920",
      "2966",
      "299",
      "341",
      "342",
      "343",
      "351",
      "376",
      "379",
      "381",
      "3833",
      "385",
      "387",
      "388",
    ],
  ],
  ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"],
  ["Aruba", ["america", "carribean"], "aw", "297"],
  [
    "Australia",
    ["oceania"],
    "au",
    "61",
    "(..) .... ....",
    0,
    ["2", "3", "4", "7", "8", "02", "03", "04", "07", "08"],
  ],
  ["Austria", ["europe", "eu-union"], "at", "43"],
  ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."],
  ["Bahamas", ["america", "carribean"], "bs", "1242"],
  ["Bahrain", ["middle-east"], "bh", "973"],
  ["Bangladesh", ["asia"], "bd", "880"],
  ["Barbados", ["america", "carribean"], "bb", "1246"],
  ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."],
  ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."],
  ["Belize", ["america", "central-america"], "bz", "501"],
  ["Benin", ["africa"], "bj", "229"],
  ["Bhutan", ["asia"], "bt", "975"],
  ["Bolivia", ["america", "south-america"], "bo", "591"],
  ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"],
  ["Botswana", ["africa"], "bw", "267"],
  ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."],
  ["British Indian Ocean Territory", ["asia"], "io", "246"],
  ["Brunei", ["asia"], "bn", "673"],
  ["Bulgaria", ["europe", "eu-union"], "bg", "359"],
  ["Burkina Faso", ["africa"], "bf", "226"],
  ["Burundi", ["africa"], "bi", "257"],
  ["Cambodia", ["asia"], "kh", "855"],
  ["Cameroon", ["africa"], "cm", "237"],

  ["Cape Verde", ["africa"], "cv", "238"],
  ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1],
  ["Central African Republic", ["africa"], "cf", "236"],
  ["Chad", ["africa"], "td", "235"],
  ["Chile", ["america", "south-america"], "cl", "56"],
  ["China", ["asia"], "cn", "86", "..-........."],
  ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."],
  ["Comoros", ["africa"], "km", "269"],
  ["Congo", ["africa"], "cd", "243"],
  ["Congo", ["africa"], "cg", "242"],
  ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."],
  ["Côte d’Ivoire", ["africa"], "ci", "225", ".. .. .. .."],
  ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"],
  ["Cuba", ["america", "carribean"], "cu", "53"],
  ["Curaçao", ["america", "carribean"], "cw", "599", "", 0],
  ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"],
  ["Czechia", ["europe", "eu-union"], "cz", "420", "... ... ..."],
  ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."],
  ["Djibouti", ["africa"], "dj", "253"],
  ["Dominica", ["america", "carribean"], "dm", "1767"],
  [
    "Dominican Republic",
    ["america", "carribean"],
    "do",
    "1",
    "",
    2,
    ["809", "829", "849"],
  ],
  ["Ecuador", ["america", "south-america"], "ec", "593"],
  ["Egypt", ["africa", "north-africa"], "eg", "20"],
  ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."],
  ["Equatorial Guinea", ["africa"], "gq", "240"],
  ["Eritrea", ["africa"], "er", "291"],
  [
    "Estonia",
    ["europe", "eu-union", "ex-ussr", "baltic"],
    "ee",
    "372",
    ".... ......",
  ],
  ["Ethiopia", ["africa"], "et", "251"],
  ["Fiji", ["oceania"], "fj", "679"],
  ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."],
  ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."],
  ["French Guiana", ["america", "south-america"], "gf", "594"],
  ["French Polynesia", ["oceania"], "pf", "689"],
  ["Gabon", ["africa"], "ga", "241"],
  ["Gambia", ["africa"], "gm", "220"],
  ["Georgia", ["asia", "ex-ussr"], "ge", "995"],
  ["Germany", ["europe", "eu-union", "baltic"], "de", "49", "..............."],
  ["Ghana", ["africa"], "gh", "233"],
  ["Greece", ["europe", "eu-union"], "gr", "30"],
  ["Grenada", ["america", "carribean"], "gd", "1473"],
  ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0],
  ["Guam", ["oceania"], "gu", "1671"],
  ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."],
  ["Guinea", ["africa"], "gn", "224"],
  ["Guinea-Bissau", ["africa"], "gw", "245"],
  ["Guyana", ["america", "south-america"], "gy", "592"],
  ["Haiti", ["america", "carribean"], "ht", "509", "....-...."],
  ["Honduras", ["america", "central-america"], "hn", "504"],
  ["Hong Kong", ["asia"], "hk", "852", ".... ...."],
  ["Hungary", ["europe", "eu-union"], "hu", "36"],
  ["Iceland", ["europe"], "is", "354", "... ...."],
  ["India", ["asia"], "in", "91", ".....-....."],
  ["Indonesia", ["asia"], "id", "62"],
  ["Iran", ["middle-east"], "ir", "98", "... ... ...."],
  ["Iraq", ["middle-east"], "iq", "964"],
  ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."],
  ["Israel", ["middle-east"], "il", "972", "... ... ...."],
  ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0],
  ["Jamaica", ["america", "carribean"], "jm", "1876"],
  ["Japan", ["asia"], "jp", "81", "... .... ...."],
  ["Jordan", ["middle-east"], "jo", "962"],
  [
    "Kazakhstan",
    ["asia", "ex-ussr"],
    "kz",
    "7",
    "... ...-..-..",
    1,
    [
      "310",
      "311",
      "312",
      "313",
      "315",
      "318",
      "321",
      "324",
      "325",
      "326",
      "327",
      "336",
      "7172",
      "73622",
    ],
  ],
  ["Kenya", ["africa"], "ke", "254"],
  ["Kiribati", ["oceania"], "ki", "686"],
  ["Kosovo", ["europe", "ex-yugos"], "xk", "383"],
  ["Kuwait", ["middle-east"], "kw", "965"],
  ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."],
  ["Laos", ["asia"], "la", "856"],
  [
    "Latvia",
    ["europe", "eu-union", "ex-ussr", "baltic"],
    "lv",
    "371",
    ".. ... ...",
  ],
  ["Lebanon", ["middle-east"], "lb", "961"],
  ["Lesotho", ["africa"], "ls", "266"],
  ["Liberia", ["africa"], "lr", "231"],
  ["Libya", ["africa", "north-africa"], "ly", "218"],
  ["Liechtenstein", ["europe"], "li", "423"],
  ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"],
  ["Luxembourg", ["europe", "eu-union"], "lu", "352"],
  ["Macau", ["asia"], "mo", "853"],
  ["Macedonia", ["europe", "ex-yugos"], "mk", "389"],
  ["Madagascar", ["africa"], "mg", "261"],
  ["Malawi", ["africa"], "mw", "265"],
  ["Malaysia", ["asia"], "my", "60", "..-....-...."],
  ["Maldives", ["asia"], "mv", "960"],
  ["Mali", ["africa"], "ml", "223"],
  ["Malta", ["europe", "eu-union"], "mt", "356"],
  ["Marshall Islands", ["oceania"], "mh", "692"],
  ["Martinique", ["america", "carribean"], "mq", "596"],
  ["Mauritania", ["africa"], "mr", "222"],
  ["Mauritius", ["africa"], "mu", "230"],
  [
    "Mexico",
    ["america", "central-america"],
    "mx",
    "52",
    "... ... ....",
    0,
    ["55", "81", "33", "656", "664", "998", "774", "229"],
  ],
  ["Micronesia", ["oceania"], "fm", "691"],
  ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."],
  ["Monaco", ["europe"], "mc", "377"],
  ["Mongolia", ["asia"], "mn", "976"],
  ["Montenegro", ["europe", "ex-yugos"], "me", "382"],
  ["Morocco", ["africa", "north-africa"], "ma", "212"],
  ["Mozambique", ["africa"], "mz", "258"],
  ["Myanmar", ["asia"], "mm", "95"],
  ["Namibia", ["africa"], "na", "264"],
  ["Nauru", ["africa"], "nr", "674"],
  ["Nepal", ["asia"], "np", "977"],
  ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"],
  ["New Caledonia", ["oceania"], "nc", "687"],
  ["New Zealand", ["oceania"], "nz", "64", "...-...-...."],
  ["Nicaragua", ["america", "central-america"], "ni", "505"],
  ["Niger", ["africa"], "ne", "227"],
  ["Nigeria", ["africa"], "ng", "234"],
  ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."],
  ["Oman", ["middle-east"], "om", "968"],
  ["Pakistan", ["asia"], "pk", "92", "...-......."],
  ["Palau", ["oceania"], "pw", "680"],
  ["Palestine", ["middle-east"], "ps", "970"],
  ["Panama", ["america", "central-america"], "pa", "507"],
  ["Papua New Guinea", ["oceania"], "pg", "675"],
  ["Paraguay", ["america", "south-america"], "py", "595"],
  ["Peru", ["america", "south-america"], "pe", "51"],
  ["Philippines", ["asia"], "ph", "63", ".... ......."],
  ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."],
  ["Portugal", ["europe", "eu-union"], "pt", "351"],
  ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]],
  ["Qatar", ["middle-east"], "qa", "974"],
  ["Réunion", ["africa"], "re", "262"],
  ["Romania", ["europe", "eu-union"], "ro", "40"],
  [
    "Russia",
    ["europe", "asia", "ex-ussr", "baltic"],
    "ru",
    "7",
    "(...) ...-..-..",
    0,
  ],
  ["Rwanda", ["africa"], "rw", "250"],
  ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"],
  ["Saint Lucia", ["america", "carribean"], "lc", "1758"],
  ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"],
  ["Samoa", ["oceania"], "ws", "685"],
  ["San Marino", ["europe"], "sm", "378"],
  ["São Tomé and Príncipe", ["africa"], "st", "239"],
  ["Saudi Arabia", ["middle-east"], "sa", "966"],
  ["Senegal", ["africa"], "sn", "221"],
  ["Serbia", ["europe", "ex-yugos"], "rs", "381"],
  ["Seychelles", ["africa"], "sc", "248"],
  ["Sierra Leone", ["africa"], "sl", "232"],
  ["Singapore", ["asia"], "sg", "65", "....-...."],
  ["Slovakia", ["europe", "eu-union"], "sk", "421"],
  ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"],
  ["Solomon Islands", ["oceania"], "sb", "677"],
  ["Somalia", ["africa"], "so", "252"],
  ["South Africa", ["africa"], "za", "27"],
  ["South Korea", ["asia"], "kr", "82", "... .... ...."],
  ["South Sudan", ["africa", "north-africa"], "ss", "211"],
  ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."],
  ["Sri Lanka", ["asia"], "lk", "94", ".. ... ...."],
  ["Sudan", ["africa"], "sd", "249"],
  ["Suriname", ["america", "south-america"], "sr", "597"],
  ["Swaziland", ["africa"], "sz", "268"],
  ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."],
  ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."],
  ["Syria", ["middle-east"], "sy", "963"],
  ["Taiwan", ["asia"], "tw", "886"],
  ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"],
  ["Tanzania", ["africa"], "tz", "255"],
  ["Thailand", ["asia"], "th", "66"],
  ["Timor-Leste", ["asia"], "tl", "670"],
  ["Togo", ["africa"], "tg", "228"],
  ["Tonga", ["oceania"], "to", "676"],
  ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"],
  ["Tunisia", ["africa", "north-africa"], "tn", "216"],
  ["Turkey", ["europe"], "tr", "90", "... ... .. .."],
  ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"],
  ["Tuvalu", ["asia"], "tv", "688"],
  ["Uganda", ["africa"], "ug", "256"],
  ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."],
  ["United Arab Emirates", ["middle-east"], "ae", "971"],
  ["United Kingdom", ["europe", "eu-union"], "uk", "44", ".... ......"],
  ["Uruguay", ["america", "south-america"], "uy", "598"],
  ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."],
  ["Vanuatu", ["oceania"], "vu", "678"],
  ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1],
  ["Venezuela", ["america", "south-america"], "ve", "58"],
  ["Vietnam", ["asia"], "vn", "84"],
  ["Yemen", ["middle-east"], "ye", "967"],
  ["Zambia", ["africa"], "zm", "260"],
  ["Zimbabwe", ["africa"], "zw", "263"],
];

export default rawCountries;

const mappedCountriesList: MappedCountries[] = [
  {
    "country.us": {
      countryCode: "us",
      isoCode: "1",
    },
  },
  {
    "country.ca": {
      countryCode: "ca",
      isoCode: "1",
    },
  },
  {
    "country.af": {
      countryCode: "af",
      isoCode: "93",
    },
  },
  {
    "country.al": {
      countryCode: "al",
      isoCode: "355",
    },
  },
  {
    "country.dz": {
      countryCode: "dz",
      isoCode: "213",
    },
  },
  {
    "country.as": {
      countryCode: "as",
      isoCode: null,
    },
  },
  {
    "country.ad": {
      countryCode: "ad",
      isoCode: "376",
    },
  },
  {
    "country.ao": {
      countryCode: "ao",
      isoCode: "244",
    },
  },
  {
    "country.ai": {
      countryCode: "ai",
      isoCode: null,
    },
  },
  {
    "country.aq": {
      countryCode: "aq",
      isoCode: null,
    },
  },
  {
    "country.ag": {
      countryCode: "ag",
      isoCode: "1268",
    },
  },
  {
    "country.ar": {
      countryCode: "ar",
      isoCode: "54",
    },
  },
  {
    "country.am": {
      countryCode: "am",
      isoCode: "374",
    },
  },
  {
    "country.aw": {
      countryCode: "aw",
      isoCode: "297",
    },
  },
  {
    "country.au": {
      countryCode: "au",
      isoCode: "61",
    },
  },
  {
    "country.at": {
      countryCode: "at",
      isoCode: "43",
    },
  },
  {
    "country.az": {
      countryCode: "az",
      isoCode: "994",
    },
  },
  {
    "country.bs": {
      countryCode: "bs",
      isoCode: "1242",
    },
  },
  {
    "country.bh": {
      countryCode: "bh",
      isoCode: "973",
    },
  },
  {
    "country.bd": {
      countryCode: "bd",
      isoCode: "880",
    },
  },
  {
    "country.bb": {
      countryCode: "bb",
      isoCode: "1246",
    },
  },
  {
    "country.by": {
      countryCode: "by",
      isoCode: "375",
    },
  },
  {
    "country.be": {
      countryCode: "be",
      isoCode: "32",
    },
  },
  {
    "country.bz": {
      countryCode: "bz",
      isoCode: "501",
    },
  },
  {
    "country.bj": {
      countryCode: "bj",
      isoCode: "229",
    },
  },
  {
    "country.bm": {
      countryCode: "bm",
      isoCode: null,
    },
  },
  {
    "country.bt": {
      countryCode: "bt",
      isoCode: "975",
    },
  },
  {
    "country.bo": {
      countryCode: "bo",
      isoCode: "591",
    },
  },
  {
    "country.bq": {
      countryCode: "bq",
      isoCode: "599",
    },
  },
  {
    "country.ba": {
      countryCode: "ba",
      isoCode: "387",
    },
  },
  {
    "country.bw": {
      countryCode: "bw",
      isoCode: "267",
    },
  },
  {
    "country.bv": {
      countryCode: "bv",
      isoCode: null,
    },
  },
  {
    "country.br": {
      countryCode: "br",
      isoCode: "55",
    },
  },
  {
    "country.io": {
      countryCode: "io",
      isoCode: "246",
    },
  },
  {
    "country.bn": {
      countryCode: "bn",
      isoCode: "673",
    },
  },
  {
    "country.bg": {
      countryCode: "bg",
      isoCode: "359",
    },
  },
  {
    "country.bf": {
      countryCode: "bf",
      isoCode: "226",
    },
  },
  {
    "country.bi": {
      countryCode: "bi",
      isoCode: "257",
    },
  },
  {
    "country.cv": {
      countryCode: "cv",
      isoCode: "238",
    },
  },
  {
    "country.kh": {
      countryCode: "kh",
      isoCode: "855",
    },
  },
  {
    "country.cm": {
      countryCode: "cm",
      isoCode: "237",
    },
  },
  {
    "country.ky": {
      countryCode: "ky",
      isoCode: null,
    },
  },
  {
    "country.cf": {
      countryCode: "cf",
      isoCode: "236",
    },
  },
  {
    "country.td": {
      countryCode: "td",
      isoCode: "235",
    },
  },
  {
    "country.cl": {
      countryCode: "cl",
      isoCode: "56",
    },
  },
  {
    "country.cn": {
      countryCode: "cn",
      isoCode: "86",
    },
  },
  {
    "country.cx": {
      countryCode: "cx",
      isoCode: null,
    },
  },
  {
    "country.cc": {
      countryCode: "cc",
      isoCode: null,
    },
  },
  {
    "country.co": {
      countryCode: "co",
      isoCode: "57",
    },
  },
  {
    "country.km": {
      countryCode: "km",
      isoCode: "269",
    },
  },
  {
    "country.cd": {
      countryCode: "cd",
      isoCode: "243",
    },
  },
  {
    "country.cg": {
      countryCode: "cg",
      isoCode: "242",
    },
  },
  {
    "country.ck": {
      countryCode: "ck",
      isoCode: null,
    },
  },
  {
    "country.cr": {
      countryCode: "cr",
      isoCode: "506",
    },
  },
  {
    "country.hr": {
      countryCode: "hr",
      isoCode: "385",
    },
  },
  {
    "country.cu": {
      countryCode: "cu",
      isoCode: "53",
    },
  },
  {
    "country.cw": {
      countryCode: "cw",
      isoCode: "599",
    },
  },
  {
    "country.cy": {
      countryCode: "cy",
      isoCode: "357",
    },
  },
  {
    "country.cz": {
      countryCode: "cz",
      isoCode: "420",
    },
  },
  {
    "country.ci": {
      countryCode: "ci",
      isoCode: "225",
    },
  },
  {
    "country.dk": {
      countryCode: "dk",
      isoCode: "45",
    },
  },
  {
    "country.dj": {
      countryCode: "dj",
      isoCode: "253",
    },
  },
  {
    "country.dm": {
      countryCode: "dm",
      isoCode: "1767",
    },
  },
  {
    "country.do": {
      countryCode: "do",
      isoCode: "1",
    },
  },
  {
    "country.ec": {
      countryCode: "ec",
      isoCode: "593",
    },
  },
  {
    "country.eg": {
      countryCode: "eg",
      isoCode: "20",
    },
  },
  {
    "country.sv": {
      countryCode: "sv",
      isoCode: "503",
    },
  },
  {
    "country.gq": {
      countryCode: "gq",
      isoCode: "240",
    },
  },
  {
    "country.er": {
      countryCode: "er",
      isoCode: "291",
    },
  },
  {
    "country.ee": {
      countryCode: "ee",
      isoCode: "372",
    },
  },
  {
    "country.sz": {
      countryCode: "sz",
      isoCode: "268",
    },
  },
  {
    "country.et": {
      countryCode: "et",
      isoCode: "251",
    },
  },
  {
    "country.fk": {
      countryCode: "fk",
      isoCode: null,
    },
  },
  {
    "country.fo": {
      countryCode: "fo",
      isoCode: null,
    },
  },
  {
    "country.fj": {
      countryCode: "fj",
      isoCode: "679",
    },
  },
  {
    "country.fi": {
      countryCode: "fi",
      isoCode: "358",
    },
  },
  {
    "country.fr": {
      countryCode: "fr",
      isoCode: "33",
    },
  },
  {
    "country.gf": {
      countryCode: "gf",
      isoCode: "594",
    },
  },
  {
    "country.pf": {
      countryCode: "pf",
      isoCode: "689",
    },
  },
  {
    "country.tf": {
      countryCode: "tf",
      isoCode: null,
    },
  },
  {
    "country.ga": {
      countryCode: "ga",
      isoCode: "241",
    },
  },
  {
    "country.gm": {
      countryCode: "gm",
      isoCode: "220",
    },
  },
  {
    "country.ge": {
      countryCode: "ge",
      isoCode: "995",
    },
  },
  {
    "country.de": {
      countryCode: "de",
      isoCode: "49",
    },
  },
  {
    "country.gh": {
      countryCode: "gh",
      isoCode: "233",
    },
  },
  {
    "country.gi": {
      countryCode: "gi",
      isoCode: null,
    },
  },
  {
    "country.gr": {
      countryCode: "gr",
      isoCode: "30",
    },
  },
  {
    "country.gl": {
      countryCode: "gl",
      isoCode: null,
    },
  },
  {
    "country.gd": {
      countryCode: "gd",
      isoCode: "1473",
    },
  },
  {
    "country.gp": {
      countryCode: "gp",
      isoCode: "590",
    },
  },
  {
    "country.gu": {
      countryCode: "gu",
      isoCode: "1671",
    },
  },
  {
    "country.gt": {
      countryCode: "gt",
      isoCode: "502",
    },
  },
  {
    "country.gg": {
      countryCode: "gg",
      isoCode: null,
    },
  },
  {
    "country.gn": {
      countryCode: "gn",
      isoCode: "224",
    },
  },
  {
    "country.gw": {
      countryCode: "gw",
      isoCode: "245",
    },
  },
  {
    "country.gy": {
      countryCode: "gy",
      isoCode: "592",
    },
  },
  {
    "country.ht": {
      countryCode: "ht",
      isoCode: "509",
    },
  },
  {
    "country.hm": {
      countryCode: "hm",
      isoCode: null,
    },
  },
  {
    "country.va": {
      countryCode: "va",
      isoCode: "39",
    },
  },
  {
    "country.hn": {
      countryCode: "hn",
      isoCode: "504",
    },
  },
  {
    "country.hk": {
      countryCode: "hk",
      isoCode: "852",
    },
  },
  {
    "country.hu": {
      countryCode: "hu",
      isoCode: "36",
    },
  },
  {
    "country.is": {
      countryCode: "is",
      isoCode: "354",
    },
  },
  {
    "country.in": {
      countryCode: "in",
      isoCode: "91",
    },
  },
  {
    "country.id": {
      countryCode: "id",
      isoCode: "62",
    },
  },
  {
    "country.ir": {
      countryCode: "ir",
      isoCode: "98",
    },
  },
  {
    "country.iq": {
      countryCode: "iq",
      isoCode: "964",
    },
  },
  {
    "country.ie": {
      countryCode: "ie",
      isoCode: "353",
    },
  },
  {
    "country.im": {
      countryCode: "im",
      isoCode: null,
    },
  },
  {
    "country.il": {
      countryCode: "il",
      isoCode: "972",
    },
  },
  {
    "country.it": {
      countryCode: "it",
      isoCode: "39",
    },
  },
  {
    "country.jm": {
      countryCode: "jm",
      isoCode: "1876",
    },
  },
  {
    "country.jp": {
      countryCode: "jp",
      isoCode: "81",
    },
  },
  {
    "country.je": {
      countryCode: "je",
      isoCode: null,
    },
  },
  {
    "country.jo": {
      countryCode: "jo",
      isoCode: "962",
    },
  },
  {
    "country.kz": {
      countryCode: "kz",
      isoCode: "7",
    },
  },
  {
    "country.ke": {
      countryCode: "ke",
      isoCode: "254",
    },
  },
  {
    "country.ki": {
      countryCode: "ki",
      isoCode: "686",
    },
  },
  {
    "country.kr": {
      countryCode: "kr",
      isoCode: "82",
    },
  },
  {
    "country.kw": {
      countryCode: "kw",
      isoCode: "965",
    },
  },
  {
    "country.kg": {
      countryCode: "kg",
      isoCode: "996",
    },
  },
  {
    "country.la": {
      countryCode: "la",
      isoCode: "856",
    },
  },
  {
    "country.lv": {
      countryCode: "lv",
      isoCode: "371",
    },
  },
  {
    "country.lb": {
      countryCode: "lb",
      isoCode: "961",
    },
  },
  {
    "country.ls": {
      countryCode: "ls",
      isoCode: "266",
    },
  },
  {
    "country.lr": {
      countryCode: "lr",
      isoCode: "231",
    },
  },
  {
    "country.ly": {
      countryCode: "ly",
      isoCode: "218",
    },
  },
  {
    "country.li": {
      countryCode: "li",
      isoCode: "423",
    },
  },
  {
    "country.lt": {
      countryCode: "lt",
      isoCode: "370",
    },
  },
  {
    "country.lu": {
      countryCode: "lu",
      isoCode: "352",
    },
  },
  {
    "country.mo": {
      countryCode: "mo",
      isoCode: "853",
    },
  },
  {
    "country.mg": {
      countryCode: "mg",
      isoCode: "261",
    },
  },
  {
    "country.mw": {
      countryCode: "mw",
      isoCode: "265",
    },
  },
  {
    "country.my": {
      countryCode: "my",
      isoCode: "60",
    },
  },
  {
    "country.mv": {
      countryCode: "mv",
      isoCode: "960",
    },
  },
  {
    "country.ml": {
      countryCode: "ml",
      isoCode: "223",
    },
  },
  {
    "country.mt": {
      countryCode: "mt",
      isoCode: "356",
    },
  },
  {
    "country.mh": {
      countryCode: "mh",
      isoCode: "692",
    },
  },
  {
    "country.mq": {
      countryCode: "mq",
      isoCode: "596",
    },
  },
  {
    "country.mr": {
      countryCode: "mr",
      isoCode: "222",
    },
  },
  {
    "country.mu": {
      countryCode: "mu",
      isoCode: "230",
    },
  },
  {
    "country.yt": {
      countryCode: "yt",
      isoCode: null,
    },
  },
  {
    "country.mx": {
      countryCode: "mx",
      isoCode: "52",
    },
  },
  {
    "country.fm": {
      countryCode: "fm",
      isoCode: "691",
    },
  },
  {
    "country.md": {
      countryCode: "md",
      isoCode: "373",
    },
  },
  {
    "country.mc": {
      countryCode: "mc",
      isoCode: "377",
    },
  },
  {
    "country.mn": {
      countryCode: "mn",
      isoCode: "976",
    },
  },
  {
    "country.me": {
      countryCode: "me",
      isoCode: "382",
    },
  },
  {
    "country.ms": {
      countryCode: "ms",
      isoCode: null,
    },
  },
  {
    "country.ma": {
      countryCode: "ma",
      isoCode: "212",
    },
  },
  {
    "country.mz": {
      countryCode: "mz",
      isoCode: "258",
    },
  },
  {
    "country.mm": {
      countryCode: "mm",
      isoCode: "95",
    },
  },
  {
    "country.na": {
      countryCode: "na",
      isoCode: "264",
    },
  },
  {
    "country.nr": {
      countryCode: "nr",
      isoCode: "674",
    },
  },
  {
    "country.np": {
      countryCode: "np",
      isoCode: "977",
    },
  },
  {
    "country.nl": {
      countryCode: "nl",
      isoCode: "31",
    },
  },
  {
    "country.nc": {
      countryCode: "nc",
      isoCode: "687",
    },
  },
  {
    "country.nz": {
      countryCode: "nz",
      isoCode: "64",
    },
  },
  {
    "country.ni": {
      countryCode: "ni",
      isoCode: "505",
    },
  },
  {
    "country.ne": {
      countryCode: "ne",
      isoCode: "227",
    },
  },
  {
    "country.ng": {
      countryCode: "ng",
      isoCode: "234",
    },
  },
  {
    "country.nu": {
      countryCode: "nu",
      isoCode: null,
    },
  },
  {
    "country.nf": {
      countryCode: "nf",
      isoCode: null,
    },
  },
  {
    "country.mp": {
      countryCode: "mp",
      isoCode: null,
    },
  },
  {
    "country.no": {
      countryCode: "no",
      isoCode: "47",
    },
  },
  {
    "country.om": {
      countryCode: "om",
      isoCode: "968",
    },
  },
  {
    "country.pk": {
      countryCode: "pk",
      isoCode: "92",
    },
  },
  {
    "country.pw": {
      countryCode: "pw",
      isoCode: "680",
    },
  },
  {
    "country.ps": {
      countryCode: "ps",
      isoCode: "970",
    },
  },
  {
    "country.pa": {
      countryCode: "pa",
      isoCode: "507",
    },
  },
  {
    "country.pg": {
      countryCode: "pg",
      isoCode: "675",
    },
  },
  {
    "country.py": {
      countryCode: "py",
      isoCode: "595",
    },
  },
  {
    "country.pe": {
      countryCode: "pe",
      isoCode: "51",
    },
  },
  {
    "country.ph": {
      countryCode: "ph",
      isoCode: "63",
    },
  },
  {
    "country.pn": {
      countryCode: "pn",
      isoCode: null,
    },
  },
  {
    "country.pl": {
      countryCode: "pl",
      isoCode: "48",
    },
  },
  {
    "country.pt": {
      countryCode: "pt",
      isoCode: "351",
    },
  },
  {
    "country.pr": {
      countryCode: "pr",
      isoCode: "1",
    },
  },
  {
    "country.qa": {
      countryCode: "qa",
      isoCode: "974",
    },
  },
  {
    "country.mk": {
      countryCode: "mk",
      isoCode: "389",
    },
  },
  {
    "country.ro": {
      countryCode: "ro",
      isoCode: "40",
    },
  },
  {
    "country.ru": {
      countryCode: "ru",
      isoCode: "7",
    },
  },
  {
    "country.rw": {
      countryCode: "rw",
      isoCode: "250",
    },
  },
  {
    "country.re": {
      countryCode: "re",
      isoCode: "262",
    },
  },
  {
    "country.bl": {
      countryCode: "bl",
      isoCode: null,
    },
  },
  {
    "country.sh": {
      countryCode: "sh",
      isoCode: null,
    },
  },
  {
    "country.kn": {
      countryCode: "kn",
      isoCode: "1869",
    },
  },
  {
    "country.lc": {
      countryCode: "lc",
      isoCode: "1758",
    },
  },
  {
    "country.mf": {
      countryCode: "mf",
      isoCode: null,
    },
  },
  {
    "country.pm": {
      countryCode: "pm",
      isoCode: null,
    },
  },
  {
    "country.vc": {
      countryCode: "vc",
      isoCode: "1784",
    },
  },
  {
    "country.ws": {
      countryCode: "ws",
      isoCode: "685",
    },
  },
  {
    "country.sm": {
      countryCode: "sm",
      isoCode: "378",
    },
  },
  {
    "country.st": {
      countryCode: "st",
      isoCode: "239",
    },
  },
  {
    "country.sa": {
      countryCode: "sa",
      isoCode: "966",
    },
  },
  {
    "country.sn": {
      countryCode: "sn",
      isoCode: "221",
    },
  },
  {
    "country.rs": {
      countryCode: "rs",
      isoCode: "381",
    },
  },
  {
    "country.sc": {
      countryCode: "sc",
      isoCode: "248",
    },
  },
  {
    "country.sl": {
      countryCode: "sl",
      isoCode: "232",
    },
  },
  {
    "country.sg": {
      countryCode: "sg",
      isoCode: "65",
    },
  },
  {
    "country.sx": {
      countryCode: "sx",
      isoCode: null,
    },
  },
  {
    "country.sk": {
      countryCode: "sk",
      isoCode: "421",
    },
  },
  {
    "country.si": {
      countryCode: "si",
      isoCode: "386",
    },
  },
  {
    "country.sb": {
      countryCode: "sb",
      isoCode: "677",
    },
  },
  {
    "country.so": {
      countryCode: "so",
      isoCode: "252",
    },
  },
  {
    "country.za": {
      countryCode: "za",
      isoCode: "27",
    },
  },
  {
    "country.gs": {
      countryCode: "gs",
      isoCode: null,
    },
  },
  {
    "country.ss": {
      countryCode: "ss",
      isoCode: "211",
    },
  },
  {
    "country.es": {
      countryCode: "es",
      isoCode: "34",
    },
  },
  {
    "country.lk": {
      countryCode: "lk",
      isoCode: "94",
    },
  },
  {
    "country.sd": {
      countryCode: "sd",
      isoCode: "249",
    },
  },
  {
    "country.sr": {
      countryCode: "sr",
      isoCode: "597",
    },
  },
  {
    "country.sj": {
      countryCode: "sj",
      isoCode: null,
    },
  },
  {
    "country.se": {
      countryCode: "se",
      isoCode: "46",
    },
  },
  {
    "country.ch": {
      countryCode: "ch",
      isoCode: "41",
    },
  },
  {
    "country.sy": {
      countryCode: "sy",
      isoCode: "963",
    },
  },
  {
    "country.tw": {
      countryCode: "tw",
      isoCode: "886",
    },
  },
  {
    "country.tj": {
      countryCode: "tj",
      isoCode: "992",
    },
  },
  {
    "country.tz": {
      countryCode: "tz",
      isoCode: "255",
    },
  },
  {
    "country.th": {
      countryCode: "th",
      isoCode: "66",
    },
  },
  {
    "country.tl": {
      countryCode: "tl",
      isoCode: "670",
    },
  },
  {
    "country.tg": {
      countryCode: "tg",
      isoCode: "228",
    },
  },
  {
    "country.tk": {
      countryCode: "tk",
      isoCode: null,
    },
  },
  {
    "country.to": {
      countryCode: "to",
      isoCode: "676",
    },
  },
  {
    "country.tt": {
      countryCode: "tt",
      isoCode: "1868",
    },
  },
  {
    "country.tn": {
      countryCode: "tn",
      isoCode: "216",
    },
  },
  {
    "country.tr": {
      countryCode: "tr",
      isoCode: "90",
    },
  },
  {
    "country.tm": {
      countryCode: "tm",
      isoCode: "993",
    },
  },
  {
    "country.tc": {
      countryCode: "tc",
      isoCode: null,
    },
  },
  {
    "country.tv": {
      countryCode: "tv",
      isoCode: "688",
    },
  },
  {
    "country.ug": {
      countryCode: "ug",
      isoCode: "256",
    },
  },
  {
    "country.ua": {
      countryCode: "ua",
      isoCode: "380",
    },
  },
  {
    "country.ae": {
      countryCode: "ae",
      isoCode: "971",
    },
  },
  {
    "country.uk": {
      countryCode: "uk",
      isoCode: "44",
    },
  },
  {
    "country.um": {
      countryCode: "um",
      isoCode: null,
    },
  },
  {
    "country.uy": {
      countryCode: "uy",
      isoCode: "598",
    },
  },
  {
    "country.uz": {
      countryCode: "uz",
      isoCode: "998",
    },
  },
  {
    "country.vu": {
      countryCode: "vu",
      isoCode: "678",
    },
  },
  {
    "country.ve": {
      countryCode: "ve",
      isoCode: "58",
    },
  },
  {
    "country.vn": {
      countryCode: "vn",
      isoCode: "84",
    },
  },
  {
    "country.vg": {
      countryCode: "vg",
      isoCode: null,
    },
  },
  {
    "country.vi": {
      countryCode: "vi",
      isoCode: null,
    },
  },
  {
    "country.wf": {
      countryCode: "wf",
      isoCode: null,
    },
  },
  {
    "country.eh": {
      countryCode: "eh",
      isoCode: null,
    },
  },
  {
    "country.ye": {
      countryCode: "ye",
      isoCode: "967",
    },
  },
  {
    "country.zm": {
      countryCode: "zm",
      isoCode: "260",
    },
  },
  {
    "country.zw": {
      countryCode: "zw",
      isoCode: "263",
    },
  },
  {
    "country.ax": {
      countryCode: "ax",
      isoCode: null,
    },
  },
  {
    "country.le": {
      countryCode: "le",
      isoCode: null,
    },
  },
  {
    "country.ap": {
      countryCode: "ap",
      isoCode: null,
    },
  },
  {
    "country.xk": {
      countryCode: "xk",
      isoCode: "383",
    },
  },
];

export const getMappedCountryCodeByKey = (key?: string) => {
  if (!key) {
    return null;
  }
  const mappedCountryDetails = mappedCountriesList.find(
    (obj) => Object.keys(obj)[0] === key.toLowerCase(),
  );
  if (mappedCountryDetails && mappedCountryDetails[key]) {
    return mappedCountryDetails[key].countryCode;
  }
  return null;
};

/**
 * Builds a lookup map of isoCode -> countryCode for efficient retrieval.
 * Handles null or duplicate isoCodes safely.
 */
export const buildIsoToCountryMap = (
  mappedCountriesList: MappedCountries[],
) => {
  const isoMap = new Map<string, string>();

  mappedCountriesList.forEach((item) => {
    const countryData = Object.values(item)[0];
    if (countryData?.isoCode) {
      // Only add valid isoCodes (non-null)
      isoMap.set(countryData.isoCode, countryData.countryCode);
    }
  });

  return isoMap;
};

/**
 * Finds a countryCode by isoCode using a prebuilt lookup map.
 * Returns blank string if not found or if isoCode is invalid.
 */
export const getCountryCodeByIso = (
  isoMap: Map<string, string>,
  isoCode: string | null | undefined,
): string => {
  if (!isoCode) return "";
  return isoMap.get(isoCode) ?? "";
};

export const getIsoMapCountryCode = (countryISOCode: string) => {
  if (!countryISOCode) return "";
  let cleanedISOCode = countryISOCode;
  if (countryISOCode.includes("+")) {
    cleanedISOCode = countryISOCode.replace("+", "");
  }
  const isoMap = buildIsoToCountryMap(mappedCountriesList);
  const mappedCode = getCountryCodeByIso(isoMap, cleanedISOCode);
  return mappedCode;
};
